import type {
  QueryInfoQuery,
  SearchQuery,
  UserClipsQuery,
  UserCustomClipsQuery,
} from './generated/graphql';

export type CustomClip = NonNullable<NonNullable<CustomClipResult['customClips']>[number]>;

// Search
export type PlayDetail = NonNullable<NonNullable<SearchResult['plays']>[number]>;
export type PlayFields = PlayDetail['fields'];
export type PlayVideo = NonNullable<NonNullable<PlayDetail['videos']>[number]>;
export type PlayVideos = PlayDetail['videos'];

export type QueryInfoResult = NonNullable<NonNullable<QueryInfoQuery['queryInfo']>[number]>;
export type ReelsClip = NonNullable<NonNullable<ReelsClipResult['userClips']>[number]>;
type CustomClipResult = NonNullable<UserCustomClipsQuery['userCustomClips']>;
type ReelsClipResult = NonNullable<UserClipsQuery['userClips']>;

type SearchResult = NonNullable<SearchQuery['search']>;

// Crop Ratio
export const CropRatioOption = {
  CROP_FOUR_FIVE: 'CROP_FOUR_FIVE',
  CROP_NINE_SIXTEEN: 'CROP_NINE_SIXTEEN',
  CROP_ONE_ONE: 'CROP_ONE_ONE',
} as const;

export type CropRatioOption = (typeof CropRatioOption)[keyof typeof CropRatioOption];

export const ReelsSortFieldOption = {
  CREATED_AT: 'createdAt',
  TITLE: 'title',
} as const;
export type ReelsSortFieldOption = (typeof ReelsSortFieldOption)[keyof typeof ReelsSortFieldOption];
